import { useState } from 'react';
import logo from '../assets/logo.png';

const links = [
  { href: '#home', label: 'Home' },
  { href: '#services', label: 'Services' },
  { href: '#products', label: 'Products' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
];

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-canvas/[0.92] backdrop-blur-[8px]">
      <div className="wrap flex h-[72px] items-center justify-between">
        <a href="#home" className="block" onClick={() => setOpen(false)}>
          <img src={logo} alt="Venus Solutions" className="h-[34px]" />
        </a>

        <nav
          className={`${open ? 'max-h-[320px]' : 'max-h-0'} absolute inset-x-0 top-[72px] flex flex-col gap-0 overflow-hidden border-b border-line bg-white transition-[max-height] duration-300 min-[721px]:static min-[721px]:max-h-none min-[721px]:flex-row min-[721px]:gap-8 min-[721px]:overflow-visible min-[721px]:border-none min-[721px]:bg-transparent`}
        >
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="border-t border-line px-6 py-4 text-[0.95rem] font-semibold text-navy hover:text-teal min-[721px]:border-none min-[721px]:px-0 min-[721px]:py-0"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="flex flex-col gap-[5px] p-2 min-[721px]:hidden"
        >
          <span className="h-[2px] w-6 bg-navy" />
          <span className="h-[2px] w-6 bg-navy" />
          <span className="h-[2px] w-6 bg-navy" />
        </button>
      </div>
    </header>
  );
}

export default Navbar;
